export const PROFILE = {
  name: "Anish Ravi",
  firstName: "Anish",
  initials: "AR",
  role: "Software Development Engineer",
  tagline: "Java · Spring Boot · Microservices",
  location: "Bengaluru, India",
  timezone: "Asia/Kolkata",
  email: "anishravi2002@gmail.com",
  linkedin: "https://linkedin.com/in/anishravi-swe",
  linkedinLabel: "linkedin.com/in/anishravi-swe",
  github: "https://github.com/anishravi",
  githubLabel: "github.com/anishravi",
  resume: "/AnishResume_WA.pdf",
  resumeFile: "AnishResume_WA.pdf",
  summary:
    "Software Development Engineer with nearly 2 years of experience building scalable banking and payment systems handling 2M+ daily transactions. Skilled in Java 17, Spring Boot, Microservices, Kafka, Oracle SQL, and React, with expertise in transaction processing, reconciliation, and performance optimization.",
  careerStartISO: "2024-09-01T00:00:00+05:30",
};

export const STATS = [
  { value: "2M+", label: "daily transactions processed" },
  { value: "3-way", label: "reconciliation engine shipped" },
  { value: "95%", label: "faster report generation" },
  { value: "~2 yrs", label: "building fintech systems" },
];

export const FOCUS_AREAS = [
  "Transaction Processing",
  "Reconciliation",
  "Performance Optimization",
  "Event-Driven Systems",
];

export const EXPERIENCE = [
  {
    role: "Software Development Engineer I",
    company: "Hatio Innovations Pvt. Ltd. (A BillDesk Company)",
    location: "Kochi, Kerala",
    period: "Dec 2024 – Present",
    current: true,
    chips: ["2M+ daily txns", "3-way reconciliation", "95% faster reports", "Java 8 → 17", "Angular → React"],
    highlights: [
      "Engineered backend services for a production-grade BBPS and TSP BOU platform processing 2M+ daily transactions — payment processing, Biller Connect integrations and banking workflows — using Java 17, Spring Boot, REST APIs and Apache Kafka.",
      "Eliminated duplicate biller API invocations caused by Kafka consumer rebalancing with a database-backed idempotency mechanism, preventing repeated processing of redelivered transactions.",
      "Co-engineered a production-grade 3-way reconciliation engine replacing the 2-way process, reconciling NPCI, BBPS and BCM settlement data across multiple BOUs — mismatch detection, deemed/final status handling, automated transaction repush.",
      "Accelerated high-volume reconciliation by replacing iterative database operations with ID-based, set-oriented Oracle SQL bulk updates.",
      "Optimized Spring Batch report-generation workflows, cutting execution time from 2–3 hours to under 5 minutes — a 95%+ processing-time reduction.",
      "Architected Sherlock, an internal BBPS testing and diagnostics tool used by Product, QA and Engineering to run Fetch, Payment and Click2Pay scenarios with centralized visibility into NPCI request/response data, module statuses, DB records and service logs.",
      "Delivered 3 levels of Recon 2.0 reporting — biller-wise, BOU-level and cycle-level — including BBPS batch migration, scheduled XML generation, GEFU and bank-specific Excel reports, and downloadable ZIP archives.",
      "Migrated the admin application frontend from Angular to React, and modernized backend services from Java 8 to Java 17, supporting production deployments, release stabilization, incident troubleshooting and DC/DR exercises.",
    ],
  },
  {
    role: "Software Engineer Intern",
    company: "Hatio Innovations Pvt. Ltd. (A BillDesk Company)",
    location: "Kochi, India",
    period: "Sep 2024 – Dec 2024",
    current: false,
    chips: ["3-month conversion"],
    highlights: [
      "Supported BBPS platform development and backend maintenance using Java, Spring Boot and SQL, contributing to payment-processing and banking operations.",
      "Implemented custom biller-specific reports from business requirements, supporting transaction data extraction for banking and payment operations.",
      "Earned conversion to a full-time Software Engineer within 3 months based on performance, technical contributions and adaptability.",
    ],
  },
];

export const SKILLS = [
  { group: "Languages", icon: "Braces", items: ["Java 8 / 17 / 21", "JavaScript (ES6+)"] },
  { group: "Backend", icon: "Server", items: ["Spring Boot", "Spring Batch", "Microservices", "REST APIs", "JPA / Hibernate"] },
  { group: "Messaging & Architecture", icon: "Network", items: ["Apache Kafka", "Event-Driven Architecture", "Distributed Systems"] },
  { group: "Databases", icon: "Database", items: ["Oracle SQL", "Query Optimization", "Bulk SQL Operations"] },
  { group: "Frontend", icon: "Globe", items: ["React.js", "AngularJS"] },
  { group: "AI & Developer Productivity", icon: "Sparkles", items: ["B-MAD", "PStack", "AI-Assisted Development"] },
  { group: "Testing", icon: "FlaskConical", items: ["JUnit", "Mockito", "Unit Testing", "Integration Testing"] },
  { group: "Tools & Environment", icon: "Wrench", items: ["Git", "Maven", "Linux", "Docker", "CI/CD"] },
];

export const EDUCATION = [
  {
    degree: "Master of Computer Applications (MCA)",
    institution: "Amity University",
    location: "Noida, Uttar Pradesh",
    period: "Jan 2024 – Mar 2026",
  },
  {
    degree: "Bachelor of Computer Applications (BCA)",
    institution: "Sindhi College",
    location: "Bengaluru, Karnataka",
    period: "Sep 2020 – Oct 2023",
  },
];

export const DEV_ENV = [
  { name: "MacBook Air M4", detail: "Apple Silicon daily driver", icon: "Laptop" },
  { name: "Ubuntu Linux", detail: "the Linux workspace", icon: "TerminalSquare" },
  { name: "Zsh", detail: "default shell, every day", icon: "ChevronRight" },
  { name: "GitHub", detail: "version control & shipping", icon: "Github" },
  { name: "Docker", detail: "containers & CI/CD", icon: "Container" },
];

export const TOOLBOX = ["Git", "Maven", "CI/CD", "Linux", "Oracle SQL", "Kafka"];

export const MARQUEE_ITEMS = [
  "JAVA 17",
  "SPRING BOOT",
  "MICROSERVICES",
  "APACHE KAFKA",
  "ORACLE SQL",
  "REACT",
  "DOCKER",
  "UBUNTU",
  "ZSH",
  "GIT",
  "CI/CD",
  "2M+ DAILY TRANSACTIONS",
];
